"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxItemAvatar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);










var _blobject = require('shared/selectors/blobject');
var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');
var _Avatar = require('shared/components/Avatar');





var _Avatar3 = require('web/components/Avatar'); var _Avatar4 = _interopRequireDefault(_Avatar3);

const Patient = (ps) => _react2.default.createElement(_Avatar3.PatientAvatar, { ...ps, __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}} )
const Team = (ps) => _react2.default.createElement(_Avatar3.TeamAvatar, { ...ps, __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}} )
const User = (ps) => _react2.default.createElement(_Avatar3.UserAvatar, { ...ps, __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}} )
const Group = (ps) => _react2.default.createElement(_Avatar3.GroupAvatar, { ...ps, __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}} )
const Fallback = (ps) => _react2.default.createElement(_Avatar4.default, { icon: "/assets/icons/inbox/inbox.svg", ...ps, __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}} )







const InboxItemAvatar = props => {
  const selectSubscribers = _react.useMemo.call(void 0, _blobject.makeSelectUnsafePopulatedBlobjectSubscribers, [])
  const subscribers = _hooks.useAppSelector.call(void 0, state => selectSubscribers(state, props.bkey))
  const currentUserKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)

  return (
    _react2.default.createElement(_Avatar.InboxAvatar, {
      ...props,

      currentUserKey: currentUserKey,
      subscribers: subscribers,

      renderUserAvatar: User,
      renderTeamAvatar: Team,
      renderPatientAvatar: Patient,
      renderGroupAvatar: Group,
      renderFallbackAvatar: Fallback, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
    )
  )
}

exports. default = _react.memo.call(void 0, InboxItemAvatar)
